import { CapitalizeNames as capitalize } from 'src/utils/capitalize';
import { UPPERCASE, LOWERCASE, CAPITALIZE } from 'src/constants/formatTexts';

/**
 * Formats a text according to the specified case
 * @param {Object} params - Input parameters
 * @param {string} params.text - Text to format
 * @param {string} params.textToFormat - Formatting case
 * @returns {string} Formatted text
 */

export const formatTextByCase = ({
    text,
    textToFormat,
}: {
    text: string;
    textToFormat: string;
}) => {
    switch (textToFormat) {
        case UPPERCASE:
            return text.toUpperCase();
        case LOWERCASE:
            return text.toLowerCase();
        case CAPITALIZE:
            return capitalize(text);
        default:
            return text;
    }
};
